/** CMS content languages (see directives). */
export const CMS_LANGUAGES = [
  { code: 'en', label: 'English', dir: 'ltr' },
  { code: 'ar', label: 'Arabic', dir: 'rtl' },
  { code: 'ku', label: 'Kurdish', dir: 'rtl' },
];

export const CMS_LANG_CODES = CMS_LANGUAGES.map((l) => l.code);
